import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

const compactNumberFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCompactNumber(value: number) {
  return compactNumberFormatter.format(value);
}
